import { gql } from '@apollo/client';

export const UPSERT_FILING_DISPUTE_VALUE_BY_FILING = gql`
  mutation UpsertFilingDisputeValueByFiling($companyId: ID!, $filingId: ID!, $value: Int!) {
    filingDisputeValue_upsertByFiling(companyId: $companyId, filingId: $filingId, value: $value)
  }
`;
